import axios from "axios";
import secureLocalStorage from "react-secure-storage";


const getAllNotifications = ( ) => {
    const loginData = secureLocalStorage.getItem("loginCredentials");
      return new Promise((resolve , reject)=>{
            axios.get(
                `${process.env.REACT_APP_NODE_BASE_URL}/notifications/getNotificationsbyId/${loginData.user.id}`
              ).then((res)=>{
                  resolve (res.data);
              }).catch(err=> reject(err) )
      })
  };

export {getAllNotifications}